export default __webpack_public_path__ + "static/media/warning--uneven-road--g1.7ee9ceaa.png";